const getRedirectUrl = (data, startsWithHttp = false) => {

    let origon      =   window.location.origin;
    let path        =   data?.url || '/notification_logs';
    let params      =   {};

    if (data.event === 'ticket-add') {
        path        =   '/ticket';
        params      =   { ticket_id: data?.ticket_id };
    } else if (data.event === 'deal_reminder') {
        path        =   `/deals/${data?.entity_id}`;
        params      =   {};
    }




    if(startsWithHttp) {
        const baseUrl       =   new URL(origon + path);
        if(params) {
            Object.keys(params).forEach(key => {
                baseUrl.searchParams.append(key, params[key]);
            });
        }
        return baseUrl.toString();
    } else {
        const query = new URLSearchParams(params).toString();
        return query ? `${path}?${query}` : path;
    }
}

export { 
    getRedirectUrl
}
 